import { MappingProductVersionToPlasticsStaticLabel } from './../../../../../../../../libs/prism-shared/src/lib/models/mapping-product-version-to-plastics-static-label.model';
import { createAction, createActionGroup, emptyProps, props } from "@ngrx/store";
import { BillOfMaterialsLineItem, Contact, Customer, MappingProductVersionToQualityAlert, PlasticsMaterialMixingTask, PlasticsPurchaseRequisition, PlasticsCalendarEvent, PlasticsFinishingStation, PlasticsFinishingTask, PlasticsFixture, PlasticsHardwareItem, PlasticsHardwareItemType, PlasticsMaterial, PlasticsOrder, PlasticsOrderedProduct, PlasticsQualityAlert, PlasticsScrapInstance, PlasticsScrapReason, Product, ProductInstance, InventoryTransaction, ProductType, ProductVersion, Resource, RotoMachine, RotoSchedule, SaveStatus, PlasticsMoldingTask, Tag, UploadedFile, VendorHardwareData, ComplaintLog, ComplaintLogProduct, MappingComplaintLogToQualityAlert, MappingComplaintLogToContact, LabelInstance, PlasticsSkid, PlasticsQualityAlertInspection, LabelInstance_PackingSlip, MappingProductVersionToDockInspectionQuailtyAlert, PlasticsDockInspectionInstance, PlasticsStaticLabel, MappingPlasticsMaterialToQualityAlert, ProductVersionMoldConfig } from "@prism/prism-shared";

export const LoadHardwareItems = createActionGroup({
    source: 'Plastics LoadHardwareItems',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ hardwareItems: PlasticsHardwareItem[] }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadHardwareItemById = createActionGroup({
    source: 'Plastics LoadHardwareItemById',
    events: {
        'Initial': props<{ hardwareItemId: string; }>(),
        'Success': props<{ hardwareItem: PlasticsHardwareItem; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadHardwareItemsByIds = createActionGroup({
    source: 'Plastics LoadHardwareItemsByIds',
    events: {
        'Initial': props<{ hardwareItemIds: string[]; }>(),
        'Success': props<{ hardwareItems: PlasticsHardwareItem[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadHardwareItemsByType = createActionGroup({
    source: 'Plastics LoadHardwareItemsByType',
    events: {
        'Initial': props<{ hardwareItemType: PlasticsHardwareItemType }>(),
        'Success': props<{ hardwareItems: PlasticsHardwareItem[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetHardwareItem = createActionGroup({
    source: 'Plastics SetHardwareItem',
    events: {
        'Initial': props<{ hardwareItem: PlasticsHardwareItem; }>(),
        'Success': props<{ hardwareItem: PlasticsHardwareItem; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadContacts = createActionGroup({
    source: 'Plastics LoadContacts',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ contacts: Contact[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadContactById = createActionGroup({
    source: 'Plastics LoadContactById',
    events: {
        'Initial': props<{ contactId: string; }>(),
        'Success': props<{ contact: Contact; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetContact = createActionGroup({
    source: 'Plastics SetContact',
    events: {
        'Initial': props<{ contact: Contact; }>(),
        'Success': props<{ contact: Contact; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetVendorHardwareDataAndHardwareItem = createActionGroup({
    source: 'Plastics SetVendorHardwareDataAndHardwareItem',
    events: {
        'Initial': props<{ hardwareItem: PlasticsHardwareItem; vendorHardwareData: VendorHardwareData; }>(),
        'Success': props<{ hardwareItem: PlasticsHardwareItem; vendorHardwareData: VendorHardwareData; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetVendorHardwareData = createActionGroup({
    source: 'Plastics SetVendorHardwareData',
    events: {
        'Initial': props<{ vendorHardwareData: VendorHardwareData; }>(),
        'Success': props<{ vendorHardwareData: VendorHardwareData; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadVendorHardwareData = createActionGroup({
    source: 'Plastics LoadVendorHardwareData',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ vendorHardwareData: VendorHardwareData[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadVendorHardwareDataByHardwareItemId = createActionGroup({
    source: 'Plastics LoadVendorHardwareDataByHardwareItemId',
    events: {
        'Initial': props<{ hardwareItemId: string; }>(),
        'Success': props<{ vendorHardwareData: VendorHardwareData[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadVendorHardwareDataByHardwareItemIds = createActionGroup({
    source: 'Plastics LoadVendorHardwareDataByHardwareItemIds',
    events: {
        'Initial': props<{ hardwareItemIds: string[]; }>(),
        'Success': props<{ vendorHardwareData: VendorHardwareData[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadProducts = createActionGroup({
    source: 'Plastics LoadProducts',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ products: Product[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadReleasedProductVersions = createActionGroup({
    source: 'Plastics LoadReleasedProductVersions',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ releasedProductVersions: ProductVersion[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadReleasedAndDraftProductVersions = createActionGroup({
    source: 'Plastics LoadReleasedAndDraftProductVersions',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ releasedAndDraftProductVersions: ProductVersion[] }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const LoadProductById = createActionGroup({
    source: 'Plastics LoadProductById',
    events: {
        'Initial': props<{ productId: string; }>(),
        'Success': props<{ product: Product; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadProductsByIds = createActionGroup({
    source: 'Plastics LoadProductsByIds',
    events: {
        'Initial': props<{ productIds: string[]; }>(),
        'Success': props<{ products: Product[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadProductVersionById = createActionGroup({
    source: 'Plastics LoadProductVersionById',
    events: {
        'Initial': props<{ productVersionId: string }>(),
        'Success': props<{ productVersion: ProductVersion }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadProductVersionsByIds = createActionGroup({
    source: 'Plastics LoadProductVersionsByIds',
    events: {
        'Initial': props<{ productVersionIds: string[] }>(),
        'Success': props<{ productVersions: ProductVersion[] }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadReleasedAndFinishedProductVersions = createActionGroup({
    source: 'Plastics LoadReleasedAndFinishedProductVersions',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ releasedAndFinishedProductVersions: ProductVersion[] }>(),
        'Failure': props<{ error: any }>(),
    }
});
export const LoadReleasedAndMoldedProductVersions = createActionGroup({
    source: 'Plastics LoadReleasedAndMoldedProductVersions',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ releasedAndMoldedProductVersions: ProductVersion[] }>(),
        'Failure': props<{ error: any }>(),
    }
});


export const LoadProductVersionsByFixtureId = createActionGroup({
    source: 'Plastics LoadProductVersionByFixtureId',
    events: {
        'Initial': props<{ fixtureId: string }>(),
        'Success': props<{ productVersions: ProductVersion[] }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetProduct = createActionGroup({
    source: 'Plastics SetProduct',
    events: {
        'Initial': props<{ product: Product; }>(),
        'Success': props<{ product: Product; }>(),
        'Failure': props<{ error: any }>(),
    }
});


export const SetProductVersion = createActionGroup({
    source: 'Plastics SetProductVersion',
    events: {
        'Initial': props<{ productVersion: ProductVersion; }>(),
        'Success': props<{ productVersion: ProductVersion; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetProductVersions = createActionGroup({
    source: 'Plastics SetProductVersions',
    events: {
        'Initial': props<{ productVersions: ProductVersion[] }>(),
        'Success': props<{ productVersions: ProductVersion[] }>(),
        'Failure': props<{ error: any }>()
    }
})

export const LoadBillOfMaterialsLineItems = createActionGroup({
    source: 'Plastics LoadBillOfMaterialsLineItems',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ lineItems: BillOfMaterialsLineItem[] }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const LoadBillOfMaterialsLineItemsByProductId = createActionGroup({
    source: 'Plastics LoadBillOfMaterialsLineItemsByProductId',
    events: {
        'Initial': props<{ productId: string; }>(),
        'Success': props<{ lineItems: BillOfMaterialsLineItem[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadBillOfMaterialsLineItemsByProductVersionId = createActionGroup({
    source: 'Plastics LoadBillOfMaterialsLineItemsByProductVersionId',
    events: {
        'Initial': props<{ productVersionId: string }>(),
        'Success': props<{ lineItems: BillOfMaterialsLineItem[] }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const SetBillOfMaterialsLineItems = createActionGroup({
    source: 'Plastics SetBillOfMaterialsLineItems',
    events: {
        'Initial': props<{ lineItems: BillOfMaterialsLineItem[]; }>(),
        'Success': props<{ lineItems: BillOfMaterialsLineItem[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetMappingProductVersionToQualityAlerts = createActionGroup({
    source: 'Plastics SetMappingProductVersionToQualityAlerts',
    events: {
        'Initial': props<{ mappings: MappingProductVersionToQualityAlert[]; }>(),
        'Success': props<{ mappings: MappingProductVersionToQualityAlert[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetMappingProductVersionToDockInspectionQuailtyAlert = createActionGroup({
    source: 'Plastics SetMappingProductVersionToDockInspectionQuailtyAlert',
    events: {
        'Initial': props<{ mappings: MappingProductVersionToDockInspectionQuailtyAlert[]; }>(),
        'Success': props<{ mappings: MappingProductVersionToDockInspectionQuailtyAlert[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});


export const LoadTags = createActionGroup({
    source: 'Plastics LoadTags',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ tags: Tag[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});


export const SetHardwareInventoryTransaction = createActionGroup({
    source: 'Plastics SetHardwareInventoryTransaction',
    events: {
        'Initial': props<{ hardwareId: string, qtyChange: number; comment: string; }>(),
        'Success': props<{ transaction: InventoryTransaction; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetProductInventoryTransaction = createActionGroup({
    source: 'Plastics SetProductInventoryTransaction',
    events: {
        'Initial': props<{
            productId: string,
            qtyChange: number;
            comment: string;
            hardwareIdToQuantityChangeDict: Record<string, number>;
            productIdToQuantityChangeDict: Record<string, number>;
            materialIdToQuantityChangeDict: Record<string, number>;
        }>(),
        'Success': props<{ transaction: InventoryTransaction; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetMaterialInventoryTransaction = createActionGroup({
    source: 'Plastics SetMaterialInventoryTransaction',
    events: {
        'Initial': props<{
            materialId: string,
            qtyChange: number;
            comment: string;
            hardwareIdToQuantityChangeDict: Record<string, number>;
        }>(),
        'Success': props<{ transaction: InventoryTransaction; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadRecentHardwareInventoryTransactions = createActionGroup({
    source: 'Plastics LoadRecentHardwareInventoryTransactions',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ transactions: InventoryTransaction[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadRecentProductInventoryTransactions = createActionGroup({
    source: 'Plastics LoadRecentProductInventoryTransactions',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ transactions: InventoryTransaction[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadRecentMaterialInventoryTransactions = createActionGroup({
    source: 'Plastics LoadRecentMaterialInventoryTransactions',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ transactions: InventoryTransaction[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadMaterialInventoryTransactionsByMaterialId = createActionGroup({
    source: 'Plastics LoadMaterialInventoryTransactionsByMaterialId',
    events: {
        'Initial': props<{ materialId: string; }>(),
        'Success': props<{ transactions: InventoryTransaction[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});



export const LoadRotoSchedule = createActionGroup({
    source: 'Plastics LoadRotoSchedule',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ rotoSchedule: RotoSchedule }>(),
        'Set': props<{ rotoSchedule: RotoSchedule }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetRotoSchedule = createActionGroup({
    source: 'Plastics SetRotoSchedule',
    events: {
        'Initial': props<{ rotoSchedule: RotoSchedule; }>(),
        'Success': props<{ rotoSchedule: RotoSchedule; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadMoldingTasksByIds = createActionGroup({
    source: 'Plastics LoadMoldingTasksByIds',
    events: {
        'Initial': props<{ moldingTaskIds: string[] }>(),
        'Success': props<{ moldingTasks: PlasticsMoldingTask[] }>(),
        'Set': props<{ moldingTasks: PlasticsMoldingTask[] }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetMoldingTask = createActionGroup({
    source: 'Plastics SetMoldingTask',
    events: {
        'Initial': props<{ moldingTask: PlasticsMoldingTask }>(),
        'Success': props<{ moldingTask: PlasticsMoldingTask }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetMoldingTasks = createActionGroup({
    source: 'Plastics SetMoldingTasks',
    events: {
        'Initial': props<{ tasks: PlasticsMoldingTask[] }>(),
        'Success': props<{ tasks: PlasticsMoldingTask[] }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetFinishingTasks = createActionGroup({
    source: 'Plastics SetFinishingTasks',
    events: {
        'Initial': props<{ tasks: PlasticsFinishingTask[] }>(),
        'Success': props<{ tasks: PlasticsFinishingTask[] }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadFixtures = createActionGroup({
    source: 'Plastics LoadFixtures',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ fixtures: PlasticsFixture[] }>(),
        'Failure': props<{ error: any }>()
    }
});

export const LoadFixturesByIds = createActionGroup({
    source: 'Plastics LoadFixturesByIds',
    events: {
        'Intitial': props<{ fixtureIds: string[] }>(),
        'Success': props<{ fixtures: PlasticsFixture[] }>(),
        'Failure': props<{ error: any }>()
    }
})

export const SetFixture = createActionGroup({
    source: 'Plastics SetFixture',
    events: {
        'Initial': props<{ fixture: PlasticsFixture }>(),
        'Success': props<{ fixture: PlasticsFixture }>(),
        'Failure': props<{ error: any }>()
    }
});

export const LoadFixtureById = createActionGroup({
    source: 'Plastics LoadFixtureById',
    events: {
        'Initial': props<{ fixtureId: string }>(),
        'Success': props<{ fixture: PlasticsFixture }>(),
        'Failure': props<{ error: any }>()
    }
})

export const LoadPlasticsStaticLabels = createActionGroup({
    source: 'Plastics LoadPlasticsStaticLabels',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ plasticsStaticLabels: PlasticsStaticLabel[] }>(),
        'Failure': props<{ error: any }>()
    }
})

export const SetPlasticsQualityAlert = createActionGroup({
    source: 'Plastics SetPlasticsQualityAlert',
    events: {
        'Initial': props<{ qualityAlert: PlasticsQualityAlert }>(),
        'Success': props<{ qualityAlert: PlasticsQualityAlert }>(),
        'Failure': props<{ error: any }>()
    }
});

export const LoadPlasticsQualityAlerts = createActionGroup({
    source: 'Plastics PlasticsQualityAlerts',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ plasticsQualityAlerts: PlasticsQualityAlert[] }>(),
        'Failure': props<{ error: any }>()
    }
})

export const LoadPlasticsQualityAlertsByVersionId = createActionGroup({
    source: 'Plastics LoadPlasticsQualityAlertsByVersionId',
    events: {
        'Initial': props<{ productVersionId: string }>(),
        'Success': props<{ plasticsQualityAlerts: PlasticsQualityAlert[] }>(),
        'Failure': props<{ error: any }>()
    }
})

export const LoadMappingProductVersionToQualityAlertAndProductVersions = createActionGroup({
    source: 'Plastics LoadMappingProductVersionToQualityAlertAndProductVersions',
    events: {
        'Initial': emptyProps(),
        'Success': props<{
            mappingProductVersionToQualityAlerts: MappingProductVersionToQualityAlert[];
            productVersions: ProductVersion[];
        }>(),
        'Failure': props<{ error: any }>()
    }
})

export const LoadMappingProductVersionToQualityAlertAndQualityAlerts = createActionGroup({
    source: 'Plastics LoadMappingProductVersionToQualityAlertAndQualityAlerts',
    events: {
        'Initial': emptyProps(),
        'Success': props<{
            mappingProductVersionToQualityAlerts: MappingProductVersionToQualityAlert[];
            qualityAlerts: PlasticsQualityAlert[];
        }>(),
        'Failure': props<{ error: any }>()
    }
})

export const LoadPlasticsQualityAlertInspectionChecklistData = createActionGroup({
    source: 'Plastics LoadPlasticsQualityAlertInspectionChecklistData',
    events: {
        'Initial': emptyProps(),
        'Success': props<{
            mappingProductVersionToQualityAlerts: MappingProductVersionToQualityAlert[];
            qualityAlerts: PlasticsQualityAlert[];
            rotoMachines: RotoMachine[];
            releasedProductVersions: ProductVersion[];
            qualityAlertInspections: PlasticsQualityAlertInspection[];
        }>(),
        'Failure': props<{ error: any }>()
    }
})

export const SetPlasticsQualityAlertInspection = createActionGroup({
    source: 'Plastics SetPlasticsQualityAlertInspection',
    events: {
        'Initial': props<{ inspection: PlasticsQualityAlertInspection }>(),
        'Success': props<{ inspection: PlasticsQualityAlertInspection }>(),
        'Failure': props<{ error: any }>()
    }
})

export const LoadBrowsePlasticsProductsQualityAlertData = createActionGroup({
    source: 'Plastics LoadBrowsePlasticsProductsQualityAlertData',
    events: {
        'Initial': emptyProps(),
        'Success': props<{
            mappingProductVersionToQualityAlerts: MappingProductVersionToQualityAlert[];
            qualityAlerts: PlasticsQualityAlert[];
            rotoMachines: RotoMachine[];
            rotoSchedule: RotoSchedule;
            moldingTasks: PlasticsMoldingTask[];
            releasedProductVersions: ProductVersion[];
        }>(),
        'Failure': props<{ error: any }>()
    }
})

export const LoadViewPlasticsProductsQualityAlertData = createActionGroup({
    source: 'Plastics LoadViewPlasticsProductsQualityAlertData',
    events: {
        'Initial': props<{ qualityAlertId: string }>(),
        'Success': props<{
            qualityAlert: PlasticsQualityAlert;
            releasedProductVersions: ProductVersion[];
            complaintLogs: ComplaintLog[];
        }>(),
        'Failure': props<{ error: any }>()
    }
})

export const LoadRotoMachines = createActionGroup({
    source: 'Plastics LoadRotoMachines',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ rotoMachines: RotoMachine[] }>(),
        'Failure': props<{ error: any }>()
    }
})

export const LoadRotoMachineById = createActionGroup({
    source: 'Plastics LoadRotoMachineById',
    events: {
        'Initial': props<{ rotoMachineId: string }>(),
        'Success': props<{ rotoMachine: RotoMachine }>(),
        'Failure': props<{ error: any }>()
    }
})

export const SetRotoMachine = createActionGroup({
    source: 'Plastics SetRotoMachine',
    events: {
        'Initial': props<{ machine: RotoMachine }>(),
        'Success': props<{ machine: RotoMachine }>(),
        'Failure': props<{ error: any }>()
    }
})

// =================================================================================================
export const RecordScheduledProductArmCycle = createActionGroup({
    source: 'Plastics RecordScheduledProductArmCycle',
    events: {
        'Initial': props<{
            productInstances: ProductInstance[];
            machineId: string;
            armId: string;
        }>(),
        'Success': props<{ moldingTasks: PlasticsMoldingTask[] }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadMoldingTaskDependantDataByMoldingTaskIds = createActionGroup({
    source: 'Plastics LoadMoldingTaskDependantDataByMoldingTaskIds',
    events: {
        'Initial': props<{
            moldingTaskIds: string[];
        }>(),
        'Success': props<{
            moldingTasks: PlasticsMoldingTask[];
            products: Product[];
            productVersions: ProductVersion[];
            hardwareItems: PlasticsHardwareItem[];
            materials: PlasticsMaterial[];
            billOfMaterialsLineItems: BillOfMaterialsLineItem[];
            qualityAlerts: PlasticsQualityAlert[];
            mappingProductVersionToQualityAlerts: MappingProductVersionToQualityAlert[];
            mappingPlasticsMaterialToQualityAlerts: MappingPlasticsMaterialToQualityAlert[];
        }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadProductAndProductVersionsByDrawingResourceId = createActionGroup({
    source: 'Plastics LoadProductAndProductVersionsByDrawingResourceId',
    events: {
        'Initial': props<{ resourceId: string }>(),
        'Success': props<{
            products: Product[];
            productVersions: ProductVersion[];
        }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadHardwareItemsByDrawingResourceId = createActionGroup({
    source: 'Plastics LoadHardwareItemsByDrawingResourceId',
    events: {
        'Initial': props<{ resourceId: string }>(),
        'Success': props<{ hardwareItems: PlasticsHardwareItem[]; }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetMaterial = createActionGroup({
    source: 'Plastics SetMaterial',
    events: {
        'Initial': props<{ material: PlasticsMaterial }>(),
        'Success': props<{ material: PlasticsMaterial }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadMaterialById = createActionGroup({
    source: 'Plastics LoadMaterialById',
    events: {
        'Initial': props<{ materialId: string; }>(),
        'Success': props<{ material: PlasticsMaterial }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadMaterials = createActionGroup({
    source: 'Plastics LoadMaterials',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ materials: PlasticsMaterial[] }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadMaterialsByIds = createActionGroup({
    source: 'Plastics LoadMaterialByIds',
    events: {
        'Initial': props<{ materialIds: string[] }>(),
        'Success': props<{ materials: PlasticsMaterial[] }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadScrapReasons = createActionGroup({
    source: 'Plastics LoadScrapReasons',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ scrapReasons: PlasticsScrapReason[] }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const GetPlasticsScrapInstancesByIdFromDate = createActionGroup({
    source: 'Plastics LoadScrapInstancesFromIdByDate',
    events: {
        'Initial': props<{ productId: string, date: Date }>(),
        'Success': props<{ plasticsScrapInstances: PlasticsScrapInstance[] }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadMaterialsByIngredientHardwareId = createActionGroup({
    source: 'Plastics LoadMaterialsByIngredientHardwareId',
    events: {
        'Initial': props<{ hardwareItemId: string }>(),
        'Success': props<{ materials: PlasticsMaterial[] }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const SetMaterialMixingTask = createActionGroup({
    source: 'Plastics SetMaterialMixingTask',
    events: {
        'Initial': props<{
            task: PlasticsMaterialMixingTask;
        }>(),
        'Success': props<{ task: PlasticsMaterialMixingTask }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SavePlasticsFinishingTask = createActionGroup({
    source: 'Plastics SaveFinishingTask',
    events: {
        'Initial': props<{ task: PlasticsFinishingTask }>(),
        'Success': props<{ task: PlasticsFinishingTask }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadActivePlasticsFinishingTasks = createActionGroup({
    source: 'Plastics LoadActiveFinishingTasks',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ tasks: PlasticsFinishingTask[] }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadPlasticsFinishingStations = createActionGroup({
    source: 'Plastics LoadFinishingStations',
    events: {
        'Initial': emptyProps(),
        'Success': props<{ stations: PlasticsFinishingStation[] }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetFinishingStation = createActionGroup({
    source: 'Plastics SetFinishingStation',
    events: {
        'Initial': props<{ station: PlasticsFinishingStation }>(),
        'Success': props<{ station: PlasticsFinishingStation }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadOrderAndOrderedProductsById = createActionGroup({
    source: 'Plastics LoadOrderAndOrderedProductsById',
    events: {
        'Initial': props<{ orderId: string; }>(),
        'Success': props<{
            order: PlasticsOrder;
            orderedProducts: PlasticsOrderedProduct[];
        }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadOrderAndOrderedProductByOrderedProductId = createActionGroup({
    source: 'Plastics LoadOrderByOrderedProductId',
    events: {
        'Initial': props<{ orderedProductId: string }>(),
        'Success': props<{ order: PlasticsOrder, orderedProduct: PlasticsOrderedProduct }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const LoadViewOrderData = createActionGroup({
    source: 'Plastics LoadViewOrderData',
    events: {
        'Initial': props<{ orderId: string; }>(),
        'Success': props<{
            order: PlasticsOrder;
            orderedProducts: PlasticsOrderedProduct[];
            products: Product[];
            releasedProductVersions: ProductVersion[];
            mixingTasks: PlasticsMaterialMixingTask[];
            moldingTasks: PlasticsMoldingTask[];
            finishingTasks: PlasticsFinishingTask[];
            materials: PlasticsMaterial[];
            customers: Customer[];
        }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadOrdersAndOrderedProductsByProductId = createActionGroup({
    source: 'Plastics LoadOrdersAndOrderedProductsByProductId',
    events: {
        'Initial': props<{ productId: string }>(),
        'Success': props<{ orders: PlasticsOrder[], orderedProducts: PlasticsOrderedProduct[] }>(),
        'Failure': props<{ error: any }>(),
    }
})

// export const EditPlasticsOrder = createActionGroup({
//     source: 'Plastics EditPlasticsOrder',
//     events: {
//         'SetOrderId': props<{ orderId: string }>(),
//         'SetOrderNumber': props<{ orderNumber: string }>(),
//         'SetTitle': props<{ title: string; }>(),
//         'SetCustomerId': props<{ customerId: string; }>(),
//         'SetCustomerPurchaseOrderNumber': props<{ customerPurchaseOrderNumber: string; }>(),
//         'SetQuickbooksSalesOrderId': props<{ quickbooksSalesOrderId: string; }>(),
//         'AddFiles': props<{ files: UploadedFile[]; }>(),
//         'RemoveFile': props<{ fileId: string; }>(),
//         'AddOrderedProducts': props<{ orderedProducts: PlasticsOrderedProduct[]; }>(),
//         'RemoveOrderedProduct': props<{ orderedProductId: string; }>(),
//         'SetOrderedProductDueDate': props<{
//             orderedProductId: string;
//             dueDate: Date;
//         }>(),
//         'SetOrderedProductQuantity': props<{
//             orderedProductId: string;
//             quantity: number;
//         }>(),
//         'SetOrderedProductNote': props<{
//             orderedProductId: string;
//             note: string;
//         }>(),
//         'LoadDataInitial': props<{ orderId: string; }>(),
//         'LoadDataSuccess': props<{ order: PlasticsOrder; orderedProducts: PlasticsOrderedProduct[]; }>(),
//         'LoadDataFailure': props<{ error: any; }>(),

//         'SaveInitial': emptyProps(),
//         'SaveSuccess': props<{ order: PlasticsOrder }>(),
//         'SaveFailure': props<{ error: any; }>(),

//         'ReleaseInitial': emptyProps(),
//         'ReleaseSuccess': props<{ order: PlasticsOrder; orderedProducts: PlasticsOrderedProduct[]; }>(),
//         'ReleaseFailure': props<{ error: any; }>(),

//         'SetSaveStatus': props<{ saveStatus: SaveStatus; }>(),
//     }
// });

export const SetOrder = createActionGroup({
    source: 'Plastics SetOrder',
    events: {
        'Initial': props<{ order: PlasticsOrder; }>(),
        'Success': props<{ order: PlasticsOrder; }>(),
        'Failure': props<{ error: any; }>(),
    }
});

export const DeleteOrder = createActionGroup({
    source: 'Plastics DeleteOrder',
    events: {
        'Initial': props<{ orderId: string }>(),
        'Success': props<{ orderId: string }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const SetOrderedProducts = createActionGroup({
    source: 'Plastics SetOrderedProducts',
    events: {
        'Initial': props<{ orderedProducts: PlasticsOrderedProduct[]; }>(),
        'Success': props<{ orderedProducts: PlasticsOrderedProduct[]; }>(),
        'Failure': props<{ error: any; }>(),
    }
});

export const DeleteOrderedProduct = createActionGroup({
    source: 'Plastics DeleteOrderedProduct',
    events: {
        'Initial': props<{ orderedProductId: string; }>(),
        'Success': props<{ orderedProductId: string; }>(),
        'Failure': props<{ error: any; }>(),
    }
});

export const LoadOrderedProductsByCustomerId = createActionGroup({
    source: 'Plastics LoadOrderedProductsByCustomerId',
    events: {
        'Initial': props<{ customerId: string; }>(),
        'Success': props<{
            orderedProducts: PlasticsOrderedProduct[];
        }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadBrowseOrdersData = createActionGroup({
    source: 'Plastics LoadBrowseOrdersData',
    events: {
        'Initial': emptyProps(),
        'Success': props<{
            orders: PlasticsOrder[];
            orderedProducts: PlasticsOrderedProduct[];
            productVersions: ProductVersion[];
            skids: PlasticsSkid[];
        }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetCalendarEvent = createActionGroup({
    source: 'Plastics SetCalendarEvent',
    events: {
        'Initial': props<{ calendarEvent: PlasticsCalendarEvent }>(),
        'Success': props<{ calendarEvent: PlasticsCalendarEvent }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const SetCalendarEvents = createActionGroup({
    source: 'Plastics SetCalendarEvents',
    events: {
        'Initial': props<{ calendarEvents: PlasticsCalendarEvent[] }>(),
        'Success': props<{ calendarEvents: PlasticsCalendarEvent[] }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const LoadCalendarEvents = createActionGroup({
    source: 'Plastics LoadCalendarEvents',
    events: {
        'Initial': emptyProps,
        'Success': props<{ calendarEvents: PlasticsCalendarEvent[] }>(),
        'Failure': props<{ error: any }>()
    }
})

export const LoadCalendarEventsBetween = createActionGroup({
    source: 'Plastics LoadCalendarEventsBetween',
    events: {
        'Initial': props<{ startDate: Date, endDate: Date }>(),
        'Success': props<{ calendarEvents: PlasticsCalendarEvent[] }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const DeleteCalendarEvent = createActionGroup({
    source: 'Plastics DeleteCalendarEvent',
    events: {
        'Initial': props<{ calendarEvent: PlasticsCalendarEvent }>(),
        'Success': props<{ calendarEvent: PlasticsCalendarEvent }>(),
        'Failure': props<{ error: any }>()
    }
})
export const DeleteCalendarEventsByIds = createActionGroup({
    source: 'Plastics DeleteCalendarEventsByIds',
    events: {
        'Initial': props<{ calendarEventIds: string[] }>(),
        'Success': props<{ calendarEventIds: string[] }>(),
        'Failure': props<{ error: any }>()
    }
})

export const LoadProductionManagerData = createActionGroup({
    source: 'Plastics LoadProductionManagerData',
    events: {
        'Initial': emptyProps(),
        'Success': props<{
            orders: PlasticsOrder[];
            orderedProducts: PlasticsOrderedProduct[];
            releasedProductVersions: ProductVersion[];
            customers: Customer[];
            mixingTasks: PlasticsMaterialMixingTask[];
            materials: PlasticsMaterial[];
        }>(),
        'Failure': props<{ error: any }>()
    }
})
export const LoadComplaintLogs = createActionGroup({
    source: 'Plastics LoadComplaintLogs',
    events: {
        'Initial': emptyProps,
        'Success': props<{ complaintLogs: ComplaintLog[] }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const LoadComplaintLogById = createActionGroup({
    source: 'Plastics LoadComplaintLogById',
    events: {
        'Initial': props<{ logId: string }>(),
        'Success': props<{ complaintLog: ComplaintLog }>(),
        'Failure': props<{ error: any }>()
    }
})

export const SetComplaintLog = createActionGroup({
    source: 'Plastics SetComplaintLog',
    events: {
        'Initial': props<{ complaintLog: ComplaintLog }>(),
        'Success': props<{ complaintLog: ComplaintLog }>(),
        'Failure': props<{ error: any }>()
    }
})

export const DeleteComplaintLog = createActionGroup({
    source: 'Plastics DeleteComplaintLog',
    events: {
        'Initial': props<{ complaintLog: ComplaintLog }>(),
        'Success': props<{ complaintLog: ComplaintLog }>(),
        'Failure': props<{ error: any }>()
    }
})

export const LoadViewComplaintLogData = createActionGroup({
    source: 'Plastics LoadViewComplaintLogData',
    events: {
        'Initial': props<{ logId: string; }>(),
        'Success': props<{
            complaintLog: ComplaintLog;
            complaintLogProducts: ComplaintLogProduct[];
            productVersions: ProductVersion[];
            customer: Customer;
            mappingComplaintLogToQualityAlert: MappingComplaintLogToQualityAlert[];
            mappingComplaintLogToContact: MappingComplaintLogToContact[];
        }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetComplaintProduct = createActionGroup({
    source: 'Plastics SetComplaintProduct',
    events: {
        'Initial': props<{ complaintLogProduct: ComplaintLogProduct; }>(),
        'Success': props<{ complaintLogProduct: ComplaintLogProduct; }>(),
        'Failure': props<{ error: any; }>(),
    }
});

export const DeleteComplaintProduct = createActionGroup({
    source: 'Plastics DeleteComplaintProduct',
    events: {
        'Initial': props<{ complaintLogProduct: ComplaintLogProduct; }>(),
        'Success': props<{ complaintLogProduct: ComplaintLogProduct; }>(),
        'Failure': props<{ error: any; }>(),
    }
});

export const LoadComplaintLogsByProductId = createActionGroup({
    source: 'Plastics LoadComplaintLogsByProductId',
    events: {
        'Initial': props<{ productId: string; }>(),
        'Success': props<{ complaintLogs: ComplaintLog[]; }>(),
        'Failure': props<{ error: any; }>(),
    }
})

export const LoadComplaintLogsByCustomerId = createActionGroup({
    source: 'Plastics LoadComplaintLogsByCustomerId',
    events: {
        'Initial': props<{ customerId: string; }>(),
        'Success': props<{ complaintLogs: ComplaintLog[]; }>(),
        'Failure': props<{ error: any; }>(),
    }
})

export const LoadBrowseComplaintLogData = createActionGroup({
    source: 'Plastics LoadBrowseComplaintLogData',
    events: {
        'Initial': emptyProps,
        'Success': props<{
            complaintLogs: ComplaintLog[];
            complaintLogProducts: ComplaintLogProduct[];
            productVersions: ProductVersion[];
            customers: Customer[];
        }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const SetMaterialMixingTasks = createActionGroup({
    source: 'Plastics SetMixingTasks',
    events: {
        'Initial': props<{ tasks: PlasticsMaterialMixingTask[] }>(),
        'Success': props<{
            tasks: PlasticsMaterialMixingTask[]
        }>(),
        'Failure': props<{ error: any }>(),
    }

})
export const SetMappingComplaintLogToQualityAlerts = createActionGroup({
    source: 'Plastics SetMappingComplaintLogToQualityAlerts',
    events: {
        'Initial': props<{ mappingComplaintLogToQualityAlert: MappingComplaintLogToQualityAlert[] }>(),
        'Success': props<{ mappingComplaintLogToQualityAlert: MappingComplaintLogToQualityAlert[] }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const DeleteMaterialMixingTask = createActionGroup({
    source: 'Plastics DeleteMaterialMixingTask',
    events: {
        'Initial': props<{ taskId: string; }>(),
        'Success': props<{
            taskId: string;
        }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const SetPurchaseRequisition = createActionGroup({
    source: 'Plastics SetPurchaseRequisition',
    events: {
        'Initial': props<{ requisition: PlasticsPurchaseRequisition }>(),
        'Success': props<{ requisition: PlasticsPurchaseRequisition }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const SetPurchaseRequisitions = createActionGroup({
    source: 'Plastics SetPurchaseRequisitions',
    events: {
        'Initial': props<{ requisitions: PlasticsPurchaseRequisition[] }>(),
        'Success': props<{ requisitions: PlasticsPurchaseRequisition[] }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const DeletePurchaseRequisition = createActionGroup({
    source: 'Plastics DeletePurchaseRequisition',
    events: {
        'Initial': props<{ requisitionId: string }>(),
        'Success': props<{ requisitionId: string }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const DeletePurchaseRequisitions = createActionGroup({
    source: 'Plastics DeletePurchaseRequisitions',
    events: {
        'Initial': props<{ requisitionIds: string[] }>(),
        'Success': props<{ requisitionIds: string[] }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const LoadManageMaterialMixingTasksData = createActionGroup({
    source: 'Plastics LoadManageMaterialMixingTasksData',
    events: {
        'Initial': emptyProps(),
        'Success': props<{
            materialMixingTasks: PlasticsMaterialMixingTask[];
            productVersions: ProductVersion[];
            materials: PlasticsMaterial[];
            orderedProducts: PlasticsOrderedProduct[];
            customers: Customer[];
        }>(),
        'Failure': props<{ error: any }>(),
    }
})



export const DeleteMappingComplaintLogToQualityAlerts = createActionGroup({
    source: 'Plastics DeleteMappingComplaintLogToQualityAlerts',
    events: {
        'Initial': props<{ qualityAlertIds: string[], complaintLogId: string }>(),
        'Success': props<{ qualityAlertIds: string[] }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const SetLabelInstance = createActionGroup({
    source: 'Plastics SetLabelInstance',
    events: {
        'Initial': props<{ labelInstance: LabelInstance }>(),
        'Success': props<{ labelInstance: LabelInstance }>(),
        'Failure': props<{ error: any }>()
    }
})

export const LoadLabelInstanceById = createActionGroup({
    source: 'Plastics LoadLabelInstanceById',
    events: {
        'Initial': props<{ labelInstanceId: string }>(),
        'Success': props<{ labelInstance: LabelInstance }>(),
        'Failure': props<{ error: any }>()
    }
})

export const LoadLabelInstancesByIds = createActionGroup({
    source: 'Plastics LoadLabelInstancesByIds',
    events: {
        'Initial': props<{ labelInstanceIds: string[] }>(),
        'Success': props<{ labelInstances: LabelInstance[] }>(),
        'Failure': props<{ error: any }>()
    }
})

export const SetMappingComplaintLogToContact = createActionGroup({
    source: 'Plastics SetMappingComplaintLogToContact',
    events: {
        'Initial': props<{ mappings: MappingComplaintLogToContact[] }>(),
        'Success': props<{ mappings: MappingComplaintLogToContact[] }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const DeleteMappingComplaintLogToContact = createActionGroup({
    source: 'Plastics DeleteMappingComplaintLogToContact',
    events: {
        'Initial': props<{ mapping: MappingComplaintLogToContact; }>(),
        'Success': props<{ mapping: MappingComplaintLogToContact; }>(),
        'Failure': props<{ error: any; }>(),
    }
});

export const LoadComplaintLogsByContactId = createActionGroup({
    source: 'Plastics LoadComplaintLogsByContactId',
    events: {
        'Initial': props<{ contactId: string; }>(),
        'Success': props<{ complaintLogs: ComplaintLog[]; }>(),
        'Failure': props<{ error: any; }>(),
    }
});

export const DeleteMappingsComplaintLogToContacts = createActionGroup({
    source: 'Plastics DeleteMappingsComplaintLogToContacts',
    events: {
        'Initial': props<{ contactIds: string[], complaintLogId: string }>(),
        'Success': props<{ contactIds: string[] }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetSkid = createActionGroup({
    source: 'Plastics SetSkid',
    events: {
        'Initial': props<{ skid: PlasticsSkid }>(),
        'Success': props<{ skid: PlasticsSkid }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const SetSkids = createActionGroup({
    source: 'Plastics SetSkids',
    events: {
        'Initial': props<{ skids: PlasticsSkid[] }>(),
        'Success': props<{ skids: PlasticsSkid[] }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadSkids = createActionGroup({
    source: 'Plastics LoadSkids',
    events: {
        'Initial': emptyProps,
        'Success': props<{ skids: PlasticsSkid[] }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const LoadSkidById = createActionGroup({
    source: 'Plastics LoadSkidById',
    events: {
        'Initial': props<{ skidId: string }>(),
        'Success': props<{ skid: PlasticsSkid }>(),
        'Failure': props<{ error: any }>(),
    }
});

export const DeleteSkid = createActionGroup({
    source: 'Plastics DeleteSkid',
    events: {
        'Initial': props<{ skidId: string }>(),
        'Success': props<{ skidId: string }>(),
        'Failure': props<{ error: any }>(),
    }
})

export const SkidMultiScanState = createActionGroup({
    source: 'Plastics SkidMultiScanState',
    events: {
        'AddSkid': props<{ skid: PlasticsSkid }>(),
        'AddSkids': props<{ skids: PlasticsSkid[] }>(),
        'AddProductVersion': props<{ productVersion: ProductVersion }>(),
        'AddCustomer': props<{ customer: Customer }>(),
        'RemoveSkid': props<{ skidId: string }>(),
        'AddInspections': props<{ inspections: PlasticsDockInspectionInstance[] }>(),
        'Clear': emptyProps,
    }
})
